module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('b', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_9780813121307_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_9780813121307_Intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("George F. Hofmann and Donn A. Starry")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_9780813121307_Chapter01"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("World War I The Birth of American Armor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Dale E. Wilson")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_9780813121307_Chapter02"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("Organizational Milestones in the Development of American Armor, 1920-40")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Timothy K. Nenninger")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_9780813121307_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("The Marine Corps’s First Experience with an Amphibious Tank")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("George F. Hofmann")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_9780813121307_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("Army Doctrine and the Christie Tank Failing to Exploit the Operational Level of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("George F. Hofmann")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_9780813121307_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("World War II Armor Operations in Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Christopher R. Gabel")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_9780813121307_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("Marine Corps Armor Operations in World War II ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Joseph H. Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_9780813121307_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("Post-World War II and Korea Paying for Unpreparedness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Philip L. Bolté")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_9780813121307_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("The Marine Corps’s Struggle with Armor Doctrine during the Cold War (1945-70)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Kenneth W. Estes")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_9780813121307_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("The Patton Tanks The Cold War Learning Series")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Oscar C. Decker")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_9780813121307_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("Adaptation and Impact Mounted Combat in Vietnam")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Lewis Sorley")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_9780813121307_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("AirLand Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Richard M. Swain")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_9780813121307_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("“Lethal beyond all expectations” The Bradley Fighting Vehicle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Diane L. Urbina")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_9780813121307_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("The Abrams Tank System")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Robert J. Sunell")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_9780813121307_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("The Approach of Mounted Warfare in the Marine Corps (1970-95)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Kenneth W. Estes")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_9780813121307_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("The Hundred-Hour Thunderbolt Armor in the Gulf War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Stephen A. Bourque")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_9780813121307_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16"), _c('span', {
    staticClass: "pad1"
  }), _vm._v("Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_vm._v("Donn A. Starry")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_9780813121307_References",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_9780813121307_About_The_Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Editors and Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_9780813121307_Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07aef313","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_9780813121307_Contents.vue
// module id = 72
// module chunks = 0